var _path, _g, _circle, _circle2, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLowGasFee = function SvgLowGasFee(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_12682)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_12682",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 2H12C6.477 2 2 6.477 2 12v28c0 5.523 4.477 10 10 10h28c5.523 0 10-4.477 10-10V12c0-5.523-4.477-10-10-10Z",
    fill: "url(#paint0_linear_264_12682)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_12682)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 2H12C6.477 2 2 6.477 2 12v28c0 5.523 4.477 10 10 10h28c5.523 0 10-4.477 10-10V12c0-5.523-4.477-10-10-10Z",
    fill: "url(#paint1_linear_264_12682)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25h28c5.385 0 9.75 4.365 9.75 9.75v28c0 5.385-4.365 9.75-9.75 9.75H12c-5.385 0-9.75-4.365-9.75-9.75V12c0-5.385 4.365-9.75 9.75-9.75Z",
    stroke: "url(#paint2_linear_264_12682)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_12682)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.438,
    cy: 48.37,
    rx: 9.629,
    ry: 8.969,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_264_12682)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.629,
    cy: 1.969,
    rx: 9.629,
    ry: 8.969,
    fill: "#95F0FB"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 4,
    stroke: "#C9975A",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 4,
    stroke: "#C9975A",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_264_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 34 16-16",
    stroke: "#191818",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_264_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.479 48.025V38H43.52v10.025H38L48 58l10-9.975h-5.521Z",
    fill: "url(#paint3_linear_264_12682)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_12682",
    x: -4,
    y: -4,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_12682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_12682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_12682",
    x: -9.191,
    y: 13.401,
    width: 71.258,
    height: 69.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_264_12682",
    x: 2,
    y: -33,
    width: 71.258,
    height: 69.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12682"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_264_12682",
    x: 16,
    y: 16.5,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_12682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_264_12682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_264_12682",
    x: 28,
    y: 30,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_12682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_264_12682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_12682",
    x1: 26,
    y1: 2,
    x2: 26,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_12682",
    x1: 26,
    y1: 2,
    x2: 26,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_12682",
    x1: 26,
    y1: 2,
    x2: 26,
    y2: 24.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_12682",
    x1: 48,
    y1: 38,
    x2: 48,
    y2: 59.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_12682"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgLowGasFee;